import { Admin } from "../../../domain/model/Admin";
import { Auth, AccessToken, Message } from "../../../domain/model/Auth";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { AdminRepository } from "./AdminRepository";

export class AdminRepositoryImpl implements AdminRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getAdminInfo(): Promise<Response<Admin>> {
    return this.apiService.getAdminInfo();
  }
  updateAdminInfo(admin: Admin): Promise<Response<Message>> {
    return this.apiService.updateAdminInfo(admin);
  }
}
